<script>
import shareMixin from '@/mixins/shares'

export default {
	name: 'ArticleCover',
	mixins: [shareMixin],
	props: {
		image: {
			type: String,
			default: 'main/story1.jpg',
		},
		video: {
			type: String,
		}
	},
	computed: {
		imageUrl() {
			let url = require(`../assets/${this.image}`)
			return {backgroundImage: `url(${url})`}
		},
	},
	methods: {
		getVideo(format) {
			return require(`../assets/${this.video}.${format}`)
		}
	}
}
</script>



<template>
<div class="cover">
	<div class="video" v-if="video">
		<video autoplay loop muted>
			<source :src="getVideo('mp4')" type="video/mp4">
			<source :src="getVideo('webm')" type="video/webm">
			<source :src="getVideo('ogv')" type="video/ogg">
		</video>
	</div>
	<div class="image" :style="imageUrl"  v-else></div>

	<div class="mask">
		<div class="inner">
			<slot name="title"></slot>
			<slot name="text"></slot>
		</div>
	</div>
	<div class="header clearfix">
		<router-link to="/" class="back">
			<i class="fa fa-angle-left" aria-hidden="true"></i>
			вернуться
		</router-link>
		<div class="share clearfix">
			<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
			<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
			<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
			<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
			<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
		</div>
	</div>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.cover {
	width: 100%;
	height: 550px;
	position: relative;
	background: #000;
}

.video {
	width: 100%;
	height: 100%;
	position: absolute;
	overflow: hidden;

	video {
		min-width: 100%;
		min-height: 100%;
		width: auto;
		height: auto;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

.image {
	width: 100%;
	height: 100%;
	position: absolute;
	background-size: cover;
	background-position: center;
	transition: all 300ms ease;
}

.mask {
	width: 100%;
	height: 100%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

.mask .inner {
	width: 96%;
	max-width: 1040px;
	margin: 0 auto;
}

h2 {
	width: 100%;
	margin: 0;
	font-size: 25px;
}

p {
	width: 100%;
	max-width: 740px;
	margin: 0;
	font-size: 45px;
	padding-bottom: 5vh;
	font-family: @fontLava;
	font-weight: 600;
	transition: all 200ms ease;
}

.header {

	width: 96%;
	max-width: 1040px;
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	padding-top: 25px;

	.back {
		height: 50px;
		line-height: 50px;
		font-size: 15px;
		text-transform: uppercase;
		color: @red;
		text-decoration: none;
		float: left;
	}

	.back i {
		font-size: 30px;
		padding-right: 4px;
		transform: translateX(0) translateY(4px);
		transition: transform 200ms ease;
	}

	.back:hover i {
		transform: translateX(-4px) translateY(4px);
	}

	.share {
		float: right;
	}

	.share a {
		width: 56px;
		height: 50px;
		text-align: center;
		line-height: 48px;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		border-top: 1px solid #fff;
		border-bottom: 1px solid #fff;
		border-right: 1px solid #fff;
		box-sizing: border-box;
		background: rgba(0, 0, 0, 0.4);
		transition: all 200ms ease;
	}

	.share a:first-child {
		border-left: 1px solid #fff;
	}

	.share a:hover {
		background: @red;
	}

}



@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.cover {
	width: 100%;
	height: 50vh;
}

.image {
	opacity: 0.5;
}


.mask {
	h2 {
		width: 100%;
		margin: 0;
		font-size: 16px;
	}

	p {
		width: 100%;
		max-width: 740px;
		margin: 0;
		font-size: 20px;
		padding-top: 2vh;
		padding-bottom: 2vh;
		font-family: @fontLava;
		font-weight: 600;
		transition: all 200ms ease;
	}

}


.header {
	padding-top: 0;

	.share {
		display: none;
	}
}



}


</style>



// WEBPACK FOOTER //
// ArticleCover.vue?909ef174